let scrollInterval: number | null = null;

// This is used in Reorderable to continue scrolling downwards or upwards if the user puts their cursor outside of the window

export const startAutoScroll = (cursorY: number, el: HTMLElement) => {
    stopAutoScroll(); // clear any existing

    const speed = 18; // pixels per frame
    const sensitivity = 120; // px from edge to trigger

    const container = getScrollParent(el);
    if (container == null) return;

    scrollInterval = window.setInterval(() => {
        const viewportHeight = window.innerHeight;

        if (cursorY < sensitivity) {
            // scroll up
            container.scrollTop -= speed;
        } else if (cursorY > viewportHeight - sensitivity) {
            // scroll down
            container.scrollTop += speed;
        }
    }, 16);
};

export const stopAutoScroll = () => {
    if (scrollInterval != null) {
        clearInterval(scrollInterval);
        scrollInterval = null;
    }
};

const getScrollParent = (element: HTMLElement | null): HTMLElement | null => {
    if (!element) return null;

    let parent: HTMLElement | null = element.parentElement;

    while (parent) {
        const style = getComputedStyle(parent);
        const overflowY = style.overflowY;
        const isScrollable =
            (overflowY === 'auto' || overflowY === 'scroll') &&
            parent.scrollHeight > parent.clientHeight;

        if (isScrollable) {
            return parent;
        }

        parent = parent.parentElement;
    }

    return null;
}